import { isPlatformBrowser } from '@angular/common';

import { ChangePasswordComponent } from './pages/change-password/change-password/change-password.component';
import {
  FormGroup,
  NgForm,
  NgModel,
  ReactiveFormsModule,
} from '@angular/forms';

import {
  AfterViewInit,
  Component,
  HostListener,
  Inject,
  Input,
  NgModule,
  OnChanges,
  OnInit,
  PLATFORM_ID,
  SimpleChanges,
  inject,
} from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationStart,
  Router,
  RouterOutlet,
} from '@angular/router';
import { SplashScreenComponent } from './components/splash-screen/splash-screen.component';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NewPasswordComponent } from './pages/new-password/new-password.component';
import { ChatComponent } from '../app/components/chat/chat.component';
import { GameService } from './Services/game.service';
import { filter, Subject, Subscription, takeUntil } from 'rxjs';
import { FooterComponent } from './components/footer/footer.component';
import { CustomerReviewsComponent } from './pages/landing-page/customer-reviews/customer-reviews.component';
import { AboutUsComponent } from './pages/landing-page/about-us/about-us.component';
import { GamePromoBannerComponent } from './pages/landing-page/game-promo-banner/game-promo-banner.component';
import { OnBoardingStepsComponent } from './pages/landing-page/on-boarding-steps/on-boarding-steps.component';
import { GamesLandingComponent } from './pages/landing-page/games-landing/games-landing.component';
import { SubscribeNewslettergeComponent } from './pages/landing-page/subscribe-newsletterge/subscribe-newsletterge.component';
import { SignUpPopUpComponent } from './pages/signup/sign-up-pop-up/sign-up-pop-up.component';
import { UtilsService } from './Services/utils.service';
import { ToastrService } from 'ngx-toastr';
import { ForgotChangePasswordComponent } from './forgot-change-password/forgot-change-password.component';
import { ApiCallService } from './Services/api-call-service.service';
import { ErrorhandlingService } from './Services/error-handling.service';
import { LoaderService } from './Services/loader-service.service';
import { ActivityTrackService } from './Services/activity-track.service';
import { ComingSoonComponent } from './components/coming-soon/coming-soon.component';
import { AddWalletComponent } from './common/add-wallet/add-wallet.component';
import { UserManualComponent } from './common/user-manual/user-manual.component';
import { CommonModalComponent } from './common/common-modal/common-modal.component';
import { PwaInstallService } from './Services/pwa-install.service';
import { FirebaseService } from './Services/firebase.service';
import Swal from 'sweetalert2';
declare let fbq: Function;
declare var gtag: Function;
// import { CasinoLandingComponent } from './pages/landing-page/casino-landing/casino-landing.component';
// import { GamesLandingComponent } fro./pages/landing-page/games-landing/games-landing.componentent';
// import { HeaderLandingComponent } fro./pages/landing-page/header-landing/header-landing.componentent';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    CommonModule,
    HeaderComponent,
    SplashScreenComponent,
    ChatComponent,
    NgxSpinnerModule,
    AddWalletComponent,
    // ChangePasswordComponent,
    // ForgotPasswordComponent,
    // NewPasswordComponent,
    FooterComponent,
    UserManualComponent,
    CommonModalComponent,
  ],

  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewInit, OnChanges {
  showSplashScreen = true;
  isChatOpen = false;
  addBalance = false;
  showCharacterImage = false;

  public pwaInstall = inject(PwaInstallService);
  private toastr = inject(ToastrService);
  private _firebaseService = inject(FirebaseService);
  public showInstallFloating: boolean = true;

  private isBrowser: boolean;
  redirectToSignup() {
    this.router.navigate(['/SignUp']);
  }
  constructor(
    public router: Router,
    private _loaderService: LoaderService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private gameService: GameService,
    private _utils: UtilsService,
    private apiCallService: ApiCallService,
    public ErroHandling: ErrorhandlingService,
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Check for token and get chat count on each route change
        if (this.token) {
          this.getChatCount();
        }
      }
    });
    this.ErroHandling.showModalSubject.subscribe((val: boolean) => {
      this.addBalance = val;
    });

    this.isBrowser = isPlatformBrowser(this.platformId);
    // if (this.isBrowser) {
    //   Notification.requestPermission();
    // }
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd,
        ),
      )
      .subscribe((event: NavigationEnd) => {
        this.handleRouteChange(event.urlAfterRedirects);

        // // ✅ Meta Pixel PageView
        // if (this.isBrowser && typeof fbq === 'function') {
        //   fbq('track', 'PageView');
        // }
        if (this.isBrowser) {
          // ✅ Meta Pixel PageView (Existing)
          if (typeof fbq === 'function') {
            fbq('track', 'PageView');
          }

          // ✅ Google Analytics PageView (Add This)
          if (typeof gtag === 'function') {
            gtag('config', 'G-TZ82X0Q91D', {
              page_path: event.urlAfterRedirects,
            });
          }

          // ✅ TikTok Pixel PageView (Add This)
    if (typeof (window as any).ttq !== 'undefined') {
        (window as any).ttq.page();
    }

    // ✅ Snapchat Pixel PageView (Add This)
  if (typeof (window as any).snaptr !== 'undefined') {
    (window as any).snaptr('track', 'PAGE_VIEW');
  }

          // Ensure the viewport is reset to the top on every navigation (mobile fix)
          try {
            window.scrollTo({ top: 0, left: 0 });
          } catch (e) {
            // ignore (SSR safety already handled by this.isBrowser)
          }
        }
      });

    if (this.isBrowser) {
      this.handleScreenSize();
    }
  }
  private destroy$ = new Subject<void>();
  private subscription!: Subscription;

  isShowBonusBanner(): boolean {
    const currentUrl = this.router.url;
    return (
      currentUrl === '/' ||
      currentUrl.includes('/login') ||
      currentUrl.includes('/SignUp')
    );
  }
  isBonusButton(): boolean {
    const currentUrl = this.router.url.split('?')[0];
    return currentUrl === '/';
  }

  shouldShowInstallFloating(): boolean {
    return (
      this.showInstallFloating &&
      this.isBonusButton() &&
      !this.pwaInstall.isInstalled()
    );
  }

  private isHiddenLayoutRoute(url: string): boolean {
    const currentUrl = url.split('?')[0];
    return [
      '/',
      '/login',
      '/SignUp',
      '/ForgotPassword',
      '/VerifyPayment',
      '/VerifyEmail',
      '/reset-pass',
      '/Terms&Condition',
      '/Terms&Conditions',
      '/PrivacyPolicy',
      '/Help',
      '/trending-games',
      '/dashboard/Terms&Conditions',
      '/dashboard/PrivacyPolicy',
      '/dashboard/help-support',
    ].includes(currentUrl);
  }

  ngOnInit(): void {
    //  this.handleRouting();
    if (isPlatformBrowser(this.platformId)) {
      this._firebaseService.listen();

      this.isIOS =
        /iPad|iPhone|iPod/.test(navigator.userAgent) &&
        !(window as any).MSStream;
      this.isStandalone = window.matchMedia(
        '(display-mode: standalone)',
      ).matches;
    }
    this._utils.showComponent$.subscribe((show) => {
      this.isChatOpen = show;
      // console.log('this.isChatOpen', this.isChatOpen);
      if (!show && this.token) {
        this.getChatCount();
      }
    });
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this._utils.toggleComponentVisibility(false);
      }
    });
    if (this.token) {
      this.getChatCount();
    }
    const token = this._utils.getItem('token');
    if (token && token !== '') {
      this.getChatCount();
    }
    this.ErroHandling.showModalSubject.subscribe(
      (value: boolean) => (this.addBalance = value),
    );
    this._utils.getTriggerFirebaseObservable().subscribe((show) => {
      this.checkAndRequest();
    });
    // Ensure splash screen is visible for at least 5 seconds
    setTimeout(() => {
      this.showSplashScreen = false;
    }, 5000); // Adjust the timeout duration as needed
    this.subscription = this._utils.showComponent$.subscribe((show) => {
      this.isChatOpen = show;
    });
    this.gameService
      .getTriggerObservable()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.toggleChat();
      });

    this._utils
      .getTriggerChatUnReadCountObservable()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.getChatCount();
      });
    this._utils
      .getTriggerChatReadObservable()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.readChatCounts();
      });
    if (this.isShowBonusBanner()) {
      this.getSignupBonus();
    }
  }
  ngOnDestroy(): void {
    if (this.subscription) this.subscription.unsubscribe();
  }
  handleRouting() {
    const token = localStorage.getItem('token');

    const realPath = window.location.pathname;

    if (realPath.startsWith('/check')) {
      // console.log('Path is /check, skipping auth logic.');
      return;
    }

    const currentUrl = this.router.url;

    // 2. Existing logic for other routes
    if (token && currentUrl === '/') {
      this.router.navigate(['/dashboard/home']);
    } else if (!token && currentUrl !== '/') {
      this.router.navigate(['/']);
    }

    // const token = localStorage.getItem('token');
    // if (token && this.router.url === '/') {
    //   this.router.navigate(['/dashboard/home']);
    // } else if (!token || this.router.url !== '/') {
    //   this.router.navigate(['/']);
    // } else {
    //   this.router.navigate(['/login']);
    // }
  }
  // handleRouting(url?: string) {
  //   if (!this.isBrowser) { return; }

  //   // always work with the router URL, strip query params
  //   const path = (url ?? this.router.url).split('?')[0];

  //   // ↓ skip every route that *starts with* /check
  //   //     (so /check, /checkpayment, /checked, /check/foo, etc.)
  //   if (path.startsWith('/check')) {
  //     return;           // do not redirect
  //   }

  //   const token = this.token;      // uses getter, safe for SSR
  //   if (token && path === '/') {
  //     this.router.navigate(['/dashboard/home']);
  //   } else if (!token && path !== '/') {
  //     this.router.navigate(['/']);
  //   }
  // }
  async ngAfterViewInit() {
    const permission = await Notification.requestPermission();
    if (this.token) {
      // const permission = Notification.permission;
      // switch (permission) {
      //   case 'granted': {
      //     console.log('granted');
      //     const token = await this._firebaseService.init();
      //     this.sendfcmToken(token);
      //     break;
      //   }
      //   case 'denied': {
      //     console.log('denied');
      //     // ❌ DO NOT retry permission here
      //     // ✅ Instead show manual instruction UI
      //     setTimeout(() => {
      //       this.showRetryPopup(false);
      //     }, 5000);
      //     break;
      //   }
      //   default: {
      //     // 'default'
      //     console.log('default');
      //     // show your custom popup (NOT browser popup)
      //     this.showSoftPrompt();
      //     break;
      //   }
      // }
      this.checkAndRequest();
    }

    // //get the token from local storage
    // const token = localStorage.getItem('token');
    // //if token is not null
    // if (token && this.activatedRoute.snapshot.routeConfig?.path == '/') {
    //   //navigate to the dashboard
    //   this.router.navigate(['/dashboard/home']);
    //   // console.log('token exists and navigated to dashboard');
    // } else {
    //   //navigate to the landing page
    //   this.router.navigate(['/']);
    //   // console.log('token does not exist and navigated to landing');
    // }
  }
showRetryPopup(canRequest: boolean) {
  const retryTime = localStorage.getItem('notif_retry_after');

  Swal.fire({
    title: '<p class="spin-heading text-lg sm:text-xl font-bold text-white leading-none pt-4" style="font-family: \'Plus Jakarta Sans\', sans-serif; letter-spacing: -0.5px;">Notifications Disabled</p>',
    html: `
      <div class="flex flex-col items-center justify-center pt-2 pb-1 text-center" style="font-family: 'Plus Jakarta Sans', sans-serif;">
        
       

        <!-- Subtitle/Message matching text-muted slate gray -->
        <p class="text-xs sm:text-sm text-[#8a99ad] leading-relaxed px-1 sm:px-2 mb-5">
          Enable notifications to stay updated with alerts and offers.
        </p>

        <!-- Instruction Guide Box matching the theme inner field background & crisp borders -->
        <div class="w-full text-left p-3 sm:p-4 rounded-xl transition-all break-words overflow-x-auto" 
             style="background: #090c12;  color: #ffffff; font-size: 0.82rem; line-height: 1.4;">
          ${this.modalText}
        </div>
      </div>
    `,
    showCancelButton: true,
    confirmButtonText: 'I Understand',
    cancelButtonText: 'Close',
    
    background: '#0f141c',
    color: '#ffffff',
    
    customClass: {
      // Made responsive using fluid width constraints and relative padding adjustments
      popup: 'premium-themed-popup relative overflow-hidden rounded-2xl p-5 sm:p-6 w-full max-w-[calc(100%-2rem)] sm:max-w-sm shadow-2xl backdrop-blur-md mx-auto',
      confirmButton: 'w-full py-2.5 sm:py-3 rounded-xl font-semibold text-xs sm:text-sm uppercase tracking-wider transition-all active:scale-[0.98]',
      cancelButton: 'w-full py-2.5 sm:py-3 rounded-xl font-semibold text-xs sm:text-sm uppercase tracking-wider mt-2.5 transition-all active:scale-[0.98]',
      actions: 'flex flex-col w-full gap-2.5 mt-5'
    },
    
    didOpen: (popup) => {
      // 1. Inject strong override styles directly into the popup element tree
      const styleEl = document.createElement('style');
      styleEl.innerHTML = `
        /* Overwrite SweetAlert's default styles completely on sides and bottom */
        .premium-themed-popup {
          border: 1px solid #233247 !important;
          outline: none !important;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5) !important;
        }
        
        /* The exact gold reflection stroke anchored flawlessly to the top edge */
        .premium-themed-popup::before {
          content: "" !important;
          position: absolute !important;
          top: 0 !important;
          left: 0 !important;
          width: 100% !important;
          height: 1.5px !important;
          background: linear-gradient(90deg, transparent 15%, rgba(244, 194, 59, 0.3) 35%, #f4c23b 50%, rgba(244, 194, 59, 0.3) 65%, transparent 85%) !important;
          z-index: 10 !important;
        }
      `;
      popup.appendChild(styleEl);
      
      const confirmBtn = popup.querySelector('.swal2-confirm') as HTMLElement;
      const cancelBtn = popup.querySelector('.swal2-cancel') as HTMLElement;
      
      // 2. Primary Button Layout (#233247 dark-slate border match)
      if (confirmBtn) {
        confirmBtn.style.background = '#e7b53f';
        confirmBtn.style.color = '#0a0f1d';
        confirmBtn.style.border = '1px solid #233247';
        confirmBtn.style.boxShadow = 'none';
        
        confirmBtn.onmouseover = () => {
          confirmBtn.style.background = '#F5CF6B';
          confirmBtn.style.borderColor = '#2e3f56';
        };
        confirmBtn.onmouseout = () => {
          confirmBtn.style.background = '#e7b53f';
          confirmBtn.style.borderColor = '#233247';
        };
      }
      
      // 3. Secondary Cancel Button Layout
      if (cancelBtn) {
        cancelBtn.style.background = 'transparent';
        cancelBtn.style.color = '#8a99ad';
        cancelBtn.style.border = 'none';
        cancelBtn.style.boxShadow = 'none';
        
        cancelBtn.onmouseover = () => { 
          cancelBtn.style.color = '#ffffff'; 
        };
        cancelBtn.onmouseout = () => { 
          cancelBtn.style.color = '#8a99ad'; 
        };
      }
    },
    showClass: {
      popup: 'animate__animated animate__fadeInUp animate__faster'
    },
    hideClass: {
      popup: 'animate__animated animate__fadeOutDown animate__faster'
    }
  }).then((result) => {
    if (result.dismiss === Swal.DismissReason.cancel) {
      this.onMaybeLater();
    }
  });
}


showSoftPrompt() {
  const retryTime = localStorage.getItem('notif_retry_after');

  Swal.fire({
    title: '<span style="color: #e7b53f; font-family: \'Plus Jakarta Sans\', sans-serif; font-weight: 700;">Enable Notifications</span>',
    html: `
      <div class="flex flex-col items-center justify-center pt-3 pb-2 text-center" style="font-family: 'Plus Jakarta Sans', sans-serif;">
        <div class="w-20 h-20 bg-gradient-to-tr from-[rgba(231,181,63,0.04)] to-[rgba(231,181,63,0.12)] border-2 border-[rgba(231,181,63,0.25)] rounded-full flex items-center justify-center mb-5 animate-bounce shadow-inner">
          <span class="material-icons text-[#e7b53f] text-4xl">notifications_active</span>
        </div>

        <p style="color: #94a3b8; font-size: 0.82rem; max-width: 280px; margin-bottom: 1.25rem; font-weight: 500; line-height: 1.5;">
          Stay in the loop! Enable instant alerts for rewards, bonuses, and gameplay scores.
        </p>

        <div class="w-full text-left p-4 rounded-xl" 
             style="background: #080c10; border: 1px solid rgba(231, 181, 63, 0.15); color: #e2e8f0; font-size: 0.78rem; line-height: 1.4;">
          ${this.modalText}
        </div>
      </div>
    `,
    showCancelButton: true,
    confirmButtonText: 'Enable Now',
    cancelButtonText: 'Maybe Later',
    background: '#06090d',
    color: '#ffffff',
    customClass: {
      popup: 'rounded-3xl border p-6 max-w-sm shadow-2xl backdrop-blur-md',
      confirmButton: 'w-full py-3 px-4 text-slate-950 font-black text-sm rounded-xl transition-all shadow-lg active:scale-[0.98]',
      cancelButton: 'w-full py-3 px-4 bg-transparent text-slate-400 font-bold text-sm rounded-xl mt-2 transition-all',
      actions: 'flex flex-col w-full gap-1 mt-4'
    },
    didOpen: (popup) => {
      popup.style.borderColor = 'rgba(231, 181, 63, 0.25)';
      const confirmBtn = popup.querySelector('.swal2-confirm') as HTMLElement;
      const cancelBtn = popup.querySelector('.swal2-cancel') as HTMLElement;
      
      if (confirmBtn) {
        confirmBtn.style.background = '#e7b53f';
        confirmBtn.style.border = 'none';
        confirmBtn.style.color = '#0a0f1d';
        confirmBtn.onmouseover = () => confirmBtn.style.background = '#f5cf6b';
        confirmBtn.onmouseout = () => confirmBtn.style.background = '#e7b53f';
      }
      if (cancelBtn) {
        cancelBtn.style.border = '1px solid rgba(148, 163, 184, 0.15)';
        cancelBtn.onmouseover = () => { cancelBtn.style.background = 'rgba(255,255,255,0.03)'; cancelBtn.style.color = '#e2e8f0'; };
        cancelBtn.onmouseout = () => { cancelBtn.style.background = 'transparent'; cancelBtn.style.color = '#94a3b8'; };
      }
    },
    showClass: {
      popup: 'animate__animated animate__fadeInUp animate__faster'
    },
    hideClass: {
      popup: 'animate__animated animate__fadeOutDown animate__faster'
    }
  }).then((result) => {
    if (result.isConfirmed) {
      this.handleNotificationEnable('click');
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      this.onMaybeLater();
    }
  });
}
  onMaybeLater() {
    // this.setRetry(3);
  }
  setRetry(hours: number) {
    const next = Date.now() + hours * 60 * 60 * 1000;
    localStorage.setItem('notif_retry_after', next.toString());
  }
  // private _isProcessingNotification = false;
  async handleNotificationEnable(source: 'click' | 'init' = 'click') {
    // Prevent running multiple times in parallel
    // if (this._isProcessingNotification) return;
    // this._isProcessingNotification = true;

    try {
      // Browser support check
      if (!('Notification' in window)) {
        console.log('Notifications not supported');
        return;
      }

      const permission = Notification.permission;

      // CASE 1: Already allowed → directly init Firebase
      if (permission === 'granted') {
        const token = await this._firebaseService.init();
        this.sendfcmToken(token);
        return;
      }

      // CASE 2: Not decided yet → request permission
      if (permission === 'default') {
        const result = await Notification.requestPermission();

        if (result === 'granted') {
          console.log('User allowed notifications');

          const token = await this._firebaseService.init();
          this.sendfcmToken(token);
        } else {
          console.log('User denied notifications');

          if (source === 'click') {
            // this.setRetry(6);
          } else {
            this.showRetryPopup(true);
          }
        }

        return;
      }

      // CASE 3: Denied → no popup will ever show
      if (permission === 'denied') {
        console.log('Notifications blocked by user');

        if (source === 'click') {
          // this.setRetry(6);
        } else {
          this.showRetryPopup(true);
        }
      }
    } catch (error) {
      console.error('Notification error:', error);
    } finally {
      // this._isProcessingNotification = false;
    }
  }
  openChatHandler() {
    console.log('AppComponent: openChatFromHeader received');
    this.isChatOpen = true;
    this._utils.toggleComponentVisibility(true);
  }
  shouldShowChat(): boolean {
    const currentUrl = this.router.url.split('?')[0];
    const showChat = !(
      currentUrl.includes('login') ||
      currentUrl.includes('SignUp') ||
      currentUrl.includes('ForgotPassword') ||
      currentUrl.includes('VerifyPayment') ||
      currentUrl.includes('VerifyEmail') ||
      currentUrl.includes('reset-pass') ||
      currentUrl.includes('check') ||
      currentUrl.includes('dashboard/TreasurePick') ||
      currentUrl.includes('dashboard/Avaitar') ||
      currentUrl.includes('dashboard/Baccaret') ||
      currentUrl.includes('dashboard/Roulette') ||
      currentUrl.includes('dashboard/Mines') ||
      currentUrl.includes('dashboard/StackBuilder') ||
      currentUrl.includes('dashboard/Keno') ||
      currentUrl.includes('dashboard/Plinko') ||
      currentUrl === '/' ||
      this.isHiddenLayoutRoute(currentUrl) ||
      this.showSplashScreen
    );
    return showChat;
  }
  /**
   * Routes whose content is too short to reach the viewport bottom, leaving the
   * footer stranded mid-screen. These opt into a sticky-footer layout; every
   * other route keeps the default "footer flows after content" behaviour.
   */
  shouldStickFooter(): boolean {
    const currentUrl = this.router.url.split('?')[0];
    return currentUrl === '/dashboard/referallist';
  }
  shouldshowheader(): boolean {
    const currentUrl = this.router.url.split('?')[0];
    return !(
      currentUrl.includes('login') ||
      currentUrl.includes('SignUp') ||
      currentUrl.includes('ForgotPassword') ||
      currentUrl.includes('VerifyPayment') ||
      currentUrl.includes('VerifyEmail') ||
      currentUrl.includes('reset-pass') ||
      currentUrl === '/' ||
      this.isHiddenLayoutRoute(currentUrl) ||
      this.showSplashScreen
    );
  }
  get token(): string | null {
    // if (this.isBrowser) {
    const token = localStorage.getItem('token');
    return token;
    // }
    // return '';
  }

  ngOnChanges() {
    // if (this.token) {
    //   this.getChatCount();
    // }
  }
  // get chat count from notification men
  unreadCounts: number = 0;
  signupBonus: number = 0;

  getSignupBonus() {
    try {
      this.apiCallService
        .GetCallWithoutToken('TestImonials/GetSignupBonus')
        .subscribe({
          next: (response) => {
            if (response.responseCode === 200) {
              this.signupBonus = response?.data;
            }
          },
          error: (error) => {
            // this.apiCallService.handleError(error);
          },
        });
    } catch (error: any) {
      // this.apiCallService.handleError(error);
    }
  }
  async getChatCount() {
    try {
      await this.apiCallService
        .GetCallWithToken('NotificationMessages/GetUnReadChatMessages')
        .subscribe({
          next: (response) => {
            if (response.responseCode === 200) {
              this.unreadCounts = response.data[0].UnreadCount;
            }
          },
          error: (error) => {
            // this.apiCallService.handleError(error);
          },
        });
    } catch (error: any) {
      // this.apiCallService.handleError(error);
    }
  }
  async readChatCounts() {
    try {
      await this.apiCallService
        .PostCallWithToken(null, 'NotificationMessages/ReadChatMessages')
        .subscribe({
          next: (response) => {
            if (response.responseCode === 200) {
              this.unreadCounts = 0;
            }
          },
          error: (error) => {
            // this.apiCallService.handleError(error);
          },
        });
    } catch (error: any) {
      // this.apiCallService.handleError(error);
    }
  }
  toggleChat(): void {
    const newState = !this.isChatOpen;
    this._utils.toggleComponentVisibility(newState);
    if (newState) {
      this._utils.triggerChatReadFunction();
    }
  }
  // Download App
  OpenDownload() {
    this._loaderService.show();

    this.apiCallService.GetCallWithToken('AppVersion/GetAppVersion').subscribe(
      (response) => {
        if (response && response.responseCode === 200) {
          const filePath = response?.data?.appUpdateUrl;

          // Create a temporary link element
          const link = document.createElement('a');
          link.href = filePath; // Path relative to the app's root
          link.download = 'social.apk'; // Set the downloaded file name
          link.target = '_blank'; // Open in a new tab (optional)

          // Trigger the download
          link.click();

          // Clean up the temporary link element
          link.remove();
          this._loaderService.hide();
        } else {
          this.ErroHandling.handleResponseError(response);
          this._loaderService.hide();
        }
      },
      (error) => {
        this.ErroHandling.handleHttpError(error);
      },
    );
  }
  isIOS = false;
  isStandalone = false;
  shouldShowInstallButton(): boolean {
    // Show if (Android can install) OR (It is iOS and not yet installed)
    return this.pwaInstall.canInstall() || (this.isIOS && !this.isStandalone);
  }
  // async installFloating(): Promise<void> {
  //   try {
  //     if (this.pwaInstall.isInstalled()) {
  //       this.showInstallFloating = false;
  //       return;
  //     }

  //     const result = await this.pwaInstall.promptInstall();
  //     if (result === 'unavailable') {
  //       this.toastr.info(
  //         'To install: open your browser menu (⋮ or …) → "Install app" or "Add to Home Screen".',
  //         'Install Casinoze',
  //         { timeOut: 6000, positionClass: 'toast-top-center' },
  //       );
  //     } else if (result === 'accepted') {
  //       this.showInstallFloating = false;
  //       this.toastr.success('App installed successfully!', 'Casinoze', {
  //         timeOut: 3000,
  //       });
  //     }
  //   } catch (e) {
  //     // ignore
  //   }
  // }
  async installFloating(): Promise<void> {
    try {
      // 1. Check if already installed
      if (this.pwaInstall.isInstalled() || this.isStandalone) {
        this.showInstallFloating = false;
        return;
      }

      // 2. iOS Specific Flow (Manual instructions)
      if (this.isIOS) {
        // this.toastr.info(
        //   'Tap the Share button (square with arrow) and select "Add to Home Screen".',
        //   'Install App',
        //   { timeOut: 8000, positionClass: 'toast-top-center' }
        // );
        Swal.fire({
          title: 'Install Casinoze',
          html: `
            <div class="text-center">
              <p class="mb-4 text-gray-300">To Get App, follow these steps:</p>
              <div class="bg-black/20 p-4 rounded-xl text-left text-sm space-y-2 border border-white/10">
                <ol class="list-decimal list-inside space-y-1 opacity-80">
                  <li>open your browser menu (⋮) and tap share button(📤).</li>
                  <li>Select "Add to Home Screen".</li>
                </ol>
              </div>
            </div>
          `,
          icon: 'info',
          iconColor: '#7de7e5',
          confirmButtonText: 'Got it',
          background: '#0a0e1f',
          color: '#ffffff',
          customClass: {
            popup: 'swal-compact',
            confirmButton: 'btn-primary rounded-lg px-6 py-2',
          },
        });
        return;
      }

      // 3. Android/Chrome Flow (Native prompt)
      const result = await this.pwaInstall.promptInstall();

      if (result === 'unavailable') {
        // this.toastr.info(
        //   'To install: open your browser menu (⋮) and tap "Install app".',
        //   'Install App',
        //   { timeOut: 6000, positionClass: 'toast-top-center' },
        // );

        Swal.fire({
          title: 'Success!',
          html: `
            <div class="text-center">
              <p class="mb-4 text-gray-300">To install:</p>
              <div class="bg-black/20 p-4 rounded-xl text-left text-sm space-y-2 border border-white/10">
                <ol class="list-decimal list-inside space-y-1 opacity-80">
                  <li>open your browser menu (⋮)</li>
                  <li>Tap "Install app" or "Add to Home Screen".</li>
                </ol>
              </div>
            </div>
          `,
          icon: 'success',
          iconColor: '#7de7e5',
          timer: 3000,
          showConfirmButton: false,
          background: '#0a0e1f',
          color: '#ffffff',
          customClass: {
            popup: 'swal-compact',
          },
        });
      } else if (result === 'accepted') {
        this.showInstallFloating = false;
        // this.toastr.success('App installed successfully!', 'Success');

        Swal.fire({
          title: 'Success!',
          text: 'App installed successfully!',
          icon: 'success',
          iconColor: '#7de7e5',
          timer: 3000,
          showConfirmButton: false,
          background: '#0a0e1f',
          color: '#ffffff',
          customClass: {
            popup: 'swal-compact',
          },
        });
      }
    } catch (e) {
      console.error('Installation failed', e);
    }
  }

  hideInstallFloating(event: Event) {
    event.stopPropagation();
    this.showInstallFloating = false;
  }

  // hide button
  showButton: boolean = true;
  hideButton() {
    this.showButton = false;
    // setTimeout(() => {
    //   this.showButton = true;
    // }, 60000);
  }

  // 👇 Resize listener
  @HostListener('window:resize')
  onResize() {
    if (this.isBrowser) {
      this.handleScreenSize();
    }
  }

  private allowedRoutes = [
    '/dashboard/home',
    '/dashboard/wallet',
    '/dashboard/account',
    '/dashboard/lottery',
    '/dashboard/redeem',
    '/dashboard/SectrechCards',
    '/dashboard/lottery-history',
    '/',
    '/dashboard/spinner',
  ];

  handleRouteChange(url: string) {
    if (!this.isBrowser) return;

    const cleanUrl = url.split('?')[0];
    const isLargeScreen = window.innerWidth >= 1024;

    this.showCharacterImage =
      this.allowedRoutes.includes(cleanUrl) && isLargeScreen;
  }

  handleScreenSize() {
    if (!this.isBrowser) return;

    const currentUrl = this.router.url.split('?')[0];
    const isLargeScreen = window.innerWidth >= 1024;

    this.showCharacterImage =
      this.allowedRoutes.includes(currentUrl) && isLargeScreen;
  }
  isTreasurePickRoute(): boolean {
    const current = this.router.url;
    return (
      current === '/dashboard/TreasurePick' ||
      current === '/dashboard/Avaitar' ||
      current === '/dashboard/Baccaret'
    );
  }

  sendfcmToken(fcmToken: any) {
    const userId = localStorage.getItem('userId');
    const payload = {
      fcmToken: fcmToken,
      userId: Number(userId),
    };
    if (!userId) return;
    // generate random 3 alphabets and 3 digits and store in deviceUId
    this.apiCallService
      .PostCallWithToken(payload, 'User/UpdateFCMToken')
      .subscribe(
        (response) => {
          if (response && response.responseCode === 200) {
            // console.log('User logged in successfully', response);
            // Check if user type is customer
          }
        },
        (error) => {},
      );
  }
  getDeviceOS(): 'iOS' | 'Android' | 'Desktop' {
    if (typeof window === 'undefined') return 'Desktop';

    const ua = navigator.userAgent || navigator.vendor;

    if (/android/i.test(ua)) {
      return 'Android';
    }

    if (
      /iPad|iPhone|iPod/i.test(ua) ||
      (ua.includes('Mac') && navigator.maxTouchPoints > 1)
    ) {
      return 'iOS';
    }

    return 'Desktop';
  }
  async checkAndRequest() {
    const os = this.getDeviceOS();
    if (os == 'iOS' || this.isIOS) {
      // this.toastr.info(os, 'Info');

      this.showGuidedModal(os, 'denied');
    }
    const permission = Notification.permission;
    if (permission === 'denied') {
      // Show your custom Modal here
      this.showGuidedModal(os, permission);
      // this.toastr.info(os, 'Info');
    } else {
      // Logic to trigger the real FCM prompt
      this.handleNotificationEnable('init');
    }
  }
  modalText: string = '';
showGuidedModal(os: string, permission: string) {
  if (os === 'iOS') {
    this.modalText = `
      <div class="text-xs text-slate-300" style="font-family: 'Plus Jakarta Sans', sans-serif;">
        <p class="font-bold text-[#e7b53f] mb-3 uppercase tracking-wider flex items-center gap-1.5 text-[0.78rem]">
          🍎 Apple iOS Settings
        </p>
        <ol class="list-decimal list-inside space-y-2 pl-1 style-list" style="color: #94a3b8;">
          <li>Open iPhone <span style="color: #ffffff; font-weight: 600;">Settings</span></li>
          <li>Go to <span style="color: #ffffff; font-weight: 600;">Notifications</span></li>
          <li>Select <span style="color: #e7b53f; font-weight: 600;">Casinoze</span> from the app list</li>
          <li>Toggle <span class="font-bold text-emerald-400">Allow Notifications</span></li>
        </ol>
        <p class="mt-4 pt-2.5 border-t text-[11px] text-slate-500 italic" ">
          Still blocked? Check: Settings → Safari → Notifications
        </p>
      </div>
    `;
  } else if (os === 'Android') {
    this.modalText = `
      <div class="text-xs text-slate-300" style="font-family: 'Plus Jakarta Sans', sans-serif;">
        <p class="font-bold text-[#e7b53f] mb-3 uppercase tracking-wider flex items-center gap-1.5 text-[0.78rem]">
          📱 Mobile (Android Chrome)
        </p>
        <ol class="list-decimal list-inside space-y-2 pl-1 style-list" style="color: #94a3b8;">
          <li>Tap the <span style="color: #ffffff; font-weight: 600;">⋮</span> icon at top-right</li>
          <li>Open <span style="color: #ffffff; font-weight: 600;">Settings / Info</span> (ⓘ)</li>
          <li>Navigate to <span style="color: #ffffff; font-weight: 600;">Permissions</span></li>
          <li>Set <span class="font-bold text-emerald-400">Notifications → Allow</span></li>
        </ol>
      </div>
    `;
  } else {
    this.modalText = `
      <div class="text-xs text-slate-300" style="font-family: 'Plus Jakarta Sans', sans-serif;">
        <p class="font-bold text-[#e7b53f] mb-3 uppercase tracking-wider flex items-center gap-1.5 text-[0.78rem]">
           Desktop (Google Chrome)
        </p>
        <ol class="list-decimal list-inside space-y-2 pl-1 style-list" style="color: #94a3b8;">
          <li>Click the <span style="color: #ffffff; font-weight: 600;">ⓘ / 🔒 Lock</span> on address bar</li>
          <li>Open <span style="color: #ffffff; font-weight: 600;">Site Settings</span> list</li>
          <li>Locate <span style="color: #ffffff; font-weight: 600;">Notifications</span> menu</li>
          <li>Change dropdown selector to <span class="font-bold text-emerald-400">Allow</span></li>
        </ol>
      </div>
    `;
  }
  
  if (permission == 'denied') {
    this.showRetryPopup(true);
  } else {
    this.showSoftPrompt();
  }
}
}
